import { FaClock, FaCheckCircle, FaSyncAlt, FaTruck, FaTimesCircle } from "react-icons/fa";
import {
  FaMoneyBillWave,
  FaCreditCard,
  FaMobileAlt,
  FaUniversity,
} from "react-icons/fa";

// Unicode escapes - safe across any file encoding
export const RS  = "\u20B9"; // rupee sign  ₹
export const DOT = "\u00B7"; // middle dot   ·

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return iso;
  }
};

export const formatRs = (val) => {
  const n = parseFloat(val ?? 0);
  return `${RS}${n.toFixed(2)}`;
};

export const STATUS_CONFIG = {
  PENDING: {
    label: "Order Placed",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-200",
    dot: "bg-emerald-400",
    accentBar: "bg-emerald-400",
    Icon: FaClock,
  },
  CONFIRMED: {
    label: "Confirmed",
    bg: "bg-blue-50",
    text: "text-blue-700",
    border: "border-blue-200",
    dot: "bg-blue-400",
    accentBar: "bg-blue-400",
    Icon: FaCheckCircle,
  },
  ACCEPTED: {
    label: "Accepted",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-200",
    dot: "bg-emerald-400",
    accentBar: "bg-emerald-400",
    Icon: FaCheckCircle,
  },
  PROCESSING: {
    label: "Processing",
    bg: "bg-indigo-50",
    text: "text-indigo-700",
    border: "border-indigo-200",
    dot: "bg-indigo-400",
    accentBar: "bg-indigo-400",
    Icon: FaSyncAlt,
  },
  SHIPPED: {
    label: "Shipped",
    bg: "bg-cyan-50",
    text: "text-cyan-700",
    border: "border-cyan-200",
    dot: "bg-cyan-400",
    accentBar: "bg-cyan-400",
    Icon: FaTruck,
  },
  DELIVERED: {
    label: "Delivered",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-200",
    dot: "bg-emerald-400",
    accentBar: "bg-emerald-400",
    Icon: FaCheckCircle,
  },
  CANCELLED: {
    label: "Cancelled",
    bg: "bg-red-50",
    text: "text-red-700",
    border: "border-red-200",
    dot: "bg-red-400",
    accentBar: "bg-red-400",
    Icon: FaTimesCircle,
  },
};

export const PAYMENT_CONFIG = {
  COD:        { label: "Cash on Delivery", Icon: FaMoneyBillWave, color: "text-amber-600" },
  UPI:        { label: "UPI",              Icon: FaMobileAlt,      color: "text-purple-600" },
  CARD:       { label: "Card",             Icon: FaCreditCard,     color: "text-blue-600" },
  NETBANKING: { label: "Net Banking",      Icon: FaUniversity,     color: "text-indigo-600" },
  ONLINE:     { label: "Online",           Icon: FaCreditCard,     color: "text-blue-600" },
};

export const PAYMENT_STATUS_CONFIG = {
  PAID:    { label: "Paid",    bg: "bg-emerald-50", text: "text-emerald-700" },
  UNPAID:  { label: "Unpaid",  bg: "bg-orange-50",  text: "text-orange-700" },
  PENDING: { label: "Pending", bg: "bg-amber-50",   text: "text-amber-700" },
  FAILED:  { label: "Failed",  bg: "bg-red-50",     text: "text-red-700" },
};
